import { useSelector } from "react-redux";
import { RootState } from "../store";

export const useUiReducer = () => {
    return useSelector((state: RootState) => state.combinedReducer.uiReducer);
  };